// extracted by mini-css-extract-plugin
module.exports = {"tabs":"_-3owAb4","tabs__head":"_-2KOmau","tabs__items":"-W3oDAy","tabs__title":"_-3K2xcO","tabs__item":"_-3qp1Va","tabs__item_active":"_-1ehOwr"};